// components
import { NotFound } from 'system/NotFound';

export const NotFoundRoute = {
  path: '*',
  Component: NotFound,
};
